import { Component } from '@angular/core';
import BaseButtonComponent from '../base-button.component';
import { ButtonVariant } from '../../../enums/button-variant';

@Component({
  selector: 'evsb-secondary-button',
  templateUrl: '../base-button.component.html',
  styleUrls: ['../base-button.component.scss'],
})
export default class SecondaryButtonComponent extends BaseButtonComponent {
  protected variant = ButtonVariant.secondary;
}
